import { render, staticRenderFns } from "./ProductFeed.vue?vue&type=template&id=5bcae1ae&lang=pug"
import script from "./ProductFeed.vue?vue&type=script&lang=js"
export * from "./ProductFeed.vue?vue&type=script&lang=js"
import style0 from "./ProductFeed.vue?vue&type=style&index=0&id=5bcae1ae&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports